export default __webpack_public_path__ + "static/media/sentiment_angry.e4b7fa74.svg";